import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHead } from './head-context.js';

/**
 * Sets the page title (with the Thyme suffix) and, when a description key is
 * given, the meta description. During SSR the values are captured
 * synchronously into the head context so the prerender can inject them into
 * the static HTML; on the client they are applied to the document via effects.
 * @param {string} titleKey
 * @param {string} [descriptionKey]
 * @returns {void}
 */
export function usePageTitle(titleKey, descriptionKey) {
	const { t } = useTranslation();
	const head = useHead();
	const title = `${t(titleKey)} \u2014 Thyme`;
	const description = descriptionKey ? t(descriptionKey) : null;
	if (head) {
		head.current.title = title;
		if (description) { head.current.description = description; }
	}
	useEffect(() => {
		document.title = title;
		if (description) {
			let meta = document.querySelector('meta[name="description"]');
			if (!meta) {
				meta = document.createElement('meta');
				meta.setAttribute('name', 'description');
				document.head.appendChild(meta);
			}
			meta.setAttribute('content', description);
		}
	}, [title, description]);
}
